import { Navigate, Outlet } from 'react-router-dom'
import { useIsDesktop } from '@asad/crane-ui'

type DesktopOnlyRouteProps = {
  fallback: string
}

export const DesktopOnlyRoute = ({ fallback }: DesktopOnlyRouteProps) => {
  const isDesktop = useIsDesktop()

  return isDesktop ? <Outlet /> : <Navigate to={fallback} replace />
}
